import * as React from "react";
import PropTypes from "prop-types";
const SvgActivityRoutesNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M1 2.625C1 1.728 1.728 1 2.625 1h.75c.676 0 1.256.413 1.5 1h6a3.125 3.125 0 110 6.25H5.5a2.25 2.25 0 000 4.5H11v-.125c0-.897.728-1.625 1.625-1.625h.75c.897 0 1.625.728 1.625 1.625v.75c0 .897-.728 1.625-1.625 1.625h-.75a1.626 1.626 0 01-1.5-1H5.5a3.5 3.5 0 110-7h5.375a1.875 1.875 0 000-3.75H5v.125C5 4.272 4.272 5 3.375 5h-.75A1.625 1.625 0 011 3.375zm1.625-.375a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h.75a.375.375 0 00.375-.375v-.75a.375.375 0 00-.375-.375zm10 10a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h.75a.375.375 0 00.375-.375v-.75a.375.375 0 00-.375-.375z"
        fill=""
      />
    </svg>
  )
);
SvgActivityRoutesNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActivityRoutesNormalXsmall;
